<template>
 <div class="update-info-item" :style="styles"  @click="clickinfo(idx)">
  <!-- <p class="date">{{updateList.date  | infodateFormat}}</p> -->
  <h4 class="update-title">{{updateList.title}}</h4>
  <p class="update-desc" v-html="updateList.desc"></p>
 </div>
</template>

<script>

export default {
  name: 'UpdateInfoItem',
  components: {
  },
  props: {
    updateList:Object,
    colorScheme: Object,
    alphabet: String,
    idx:Number,
    lpId: {
      type: Number,
      default: 1,
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    
  },
  methods:{
    clickinfo (i) {
      if(i == 0 ){
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}-induction-button`,
          'event_label': 'anchor-link1',
        })
        location.href = this.$handoverParams('/recommend/lp/1/#hoshi-meguri')
      }else if(i == 1){
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}-induction-button`,
          'event_label': 'anchor-link2',
        })
        location.href = this.$handoverParams('/recommend/lp/1/#baika-shineki')
      }
    },
  },

  mounted(){
   // console.log(this.infodateFormat())
  },
  filters:{
    infodateFormat(val){
      return val.replace(/(-)/g,'.')
    }
    
  },
  
 
  
}

</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.update-info-item {
    padding: 16px 0;
    border-bottom: 1px solid #dadada;
}

p{
  margin:0;
}
.date{
  margin:0;
  color:$l_col_keycolor;
  font-weight: 600;
  font-size: 12px;
  line-height: 21px;
}
.update-title{
  color:$l_col_keycolor;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 0;
  margin-bottom: 8px;
  margin-top: 2px;
}

.update-desc{
 color:$l_col_keycolor;
 font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/UpdateInfoItem.vue